import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Ancient_Civilizations_-_Mesoamerica.png';

export default function HistoryPageMesoamericaGo() {
  return (
    <QuizPage
      title="History: Ancient Mesoamerica"
      subTopic="Mesoamerica"
      backgroundImage={historyImage}
      returnPath="/History-Ancient-Mesoamerica"
    />
  );
}
